import { createRouter, createWebHistory } from "vue-router";
import AirteamViewer from "../components/AirteamViewer.vue";
import Bobbie from "../components/Bobbie.vue";
import ControlCenter from "../components/ControlCenter.vue";
import { authService } from "@/services/authService.js";
import store from "@/store";

const withDefaultAuth = (routes) => {
  return routes.map((route) => {
    const newRoute = { ...route };

    if (!newRoute.meta) {
      newRoute.meta = {};
    }

    const urlParams = new URLSearchParams(window.location.search);
    const isSharedProject = urlParams.has("token");

    if (newRoute.meta.requiresAuth !== false && !isSharedProject) {
      newRoute.meta.authName = authService.oidcName;
    }
    return newRoute;
  });
};

const routes = [
  {
    path: "/:projectId?",
    component: AirteamViewer,
  },
  {
    path: "/bobbie",
    component: Bobbie,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/control-center",
    component: ControlCenter,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/bobbie-auth-required",
    name: "Bobbie Auth Required",
    component: () => import("@/components/IframeAuthGuard.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/sample",
    redirect: "/sample-1",
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/sample-1",
    component: AirteamViewer,
    props: { isSample: true, thermal: false },
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/sample-2",
    component: AirteamViewer,
    props: { isSample: true, thermal: false },
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/sample-3",
    component: AirteamViewer,
    props: { isSample: true, thermal: false },
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/sample-4",
    component: AirteamViewer,
    props: { isSample: true, thermal: false },
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/thermal",
    component: AirteamViewer,
    props: { isSample: true, thermal: true },
    meta: {
      requiresAuth: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes: withDefaultAuth(routes),
});
router.beforeEach(async (to, from, next) => {
  // Skip auth check if already going to auth guard
  if (to.path === "/bobbie-auth-required") {
    return next();
  }

  // Check if we're in a Bobbie iframe and trying to access a protected route without auth
  // const isInIframe = window.self !== window.top
  // const isBobbieContext = store.state.auth?.isBobbieContext || false
  // const needsAuth = to.meta.requiresAuth !== false && !authService.oidcAuth.isAuthenticated
  //if ((isInIframe && isBobbieContext) && needsAuth) {
  // Redirect to auth guard instead of login
  // return next({ path: '/bobbie-auth-required' })
  //}

  next();
});

router.beforeEach(async (to, from, next) => {
  // Skip auth check if already going to auth guard
  if (to.path === "/bobbie-auth-required") {
    return next();
  }

  // Check if we're in a Bobbie iframe and trying to access a protected route without auth
  const isInIframe = window.self !== window.top;
  const isBobbieContext = store.state.auth?.isBobbieContext || false;
  const isInIFrameContext = store.state.auth?.isInIFrameContext || false;
  const needsAuth =
    to.meta.requiresAuth !== false && !authService.oidcAuth.isAuthenticated;
  if (isInIframe && (isBobbieContext || isInIFrameContext) && needsAuth) {
    // Redirect to auth guard instead of login
    return next({ path: "/bobbie-auth-required" });
  }

  next();
});

export default router;
